import Vue from 'vue'
import store from '~/store'
import router from '~/router'
import i18n from '~/plugins/i18n'
import App from '~/components/App'
import VueSweetalert2 from 'vue-sweetalert2'

// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css'

import '~/plugins'
import '~/components'

Vue.config.productionTip = false

Vue.filter('calculation-price', function (value) {
  return (value.price * value.pivot.quantity).toFixed(2)
})

Vue.mixin({
  methods: {
    getModuleById (id) {
      return this.$store.getters['modules/getModuleById'](id)
    }
  }
})

Vue.use(VueSweetalert2)

/* eslint-disable no-new */
new Vue({
  i18n,
  store,
  router,
  ...App
})



// WEBPACK FOOTER //
// ./resources/js/app.js